import styled from 'styled-components';
import { forwardRef, type ReactNode } from 'react';
import { media } from 'helpers/breakpoints';

export type WhitePanelProps = {
  children: ReactNode;
  className?: string;
  testId?: string;
};

const Container = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background: ${({ theme }) => theme.colors.WHITE};
  padding: ${({ theme }) => theme.spacing.M16};

  ${media.large} {
    padding: ${({ theme }) => theme.spacing.M24};
  }
`;

const WhitePanel = forwardRef<HTMLDivElement, WhitePanelProps>((props, ref) => {
  const { className, testId, children, ...rest } = props;
  return (
    <Container ref={ref} className={className} data-testid={testId} {...rest}>
      {children}
    </Container>
  );
});

WhitePanel.displayName = 'WhitePanel';

export { WhitePanel };
